import { DayPicker, DateRange } from "react-day-picker";
import "react-day-picker/style.css";

type Props = {
  range: DateRange | undefined;
  setRange: (range: DateRange | undefined) => void;
};

export default function DateRangePicker({ range, setRange }: Props) {
  return (
    <DayPicker
      mode="range"
      selected={range}
      onSelect={setRange}
    />

  );
}